// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface ShoppingBasketSubtractIconSignature {
  Element: SVGSVGElement;
}

export const ShoppingBasketSubtractIcon: TOC<ShoppingBasketSubtractIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M20 8.99999V6.99999H16.58L12.868 0.502991L11.132 1.49499L14.277 6.99999H5.723L8.869 1.49599L7.132 0.503991L3.42 6.99999H0V8.99999H1.197L3.023 17.217C3.125 17.675 3.531 18 4 18H16C16.469 18 16.875 17.674 16.977 17.217L18.803 8.99999H20ZM15.197 16H4.803L3.246 8.99999H16.754L15.197 16ZM23 21V19H17V21H23Z"/>
</svg>
</template>;